module.exports = __webpack_public_path__ + "static/media/eduRed.ed7f321b.svg";